export const ALLOWED_FIELDS_TO_ANSWER = ['answer'];

export const ALLOWED_FIELDS_TO_UPDATE = ['question'];
